/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useEffect } from "react";
import { Image, Row, Table, Tooltip } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { statisticsSelector } from "../../../services/selector/index.";
import {
  IconNext,
  IconPre,
  IconSortDown,
  IconSortUp,
  IconSpin,
} from "../../../assets/icon";
import "../../../assets/style/table/statistics.scss";
import { useState } from "react";
import { useMemo } from "react";
import TranslateText from "../TranslateText";
import { formatDate } from "../../../utils/functionCommon";
import { getDataStatisticsBanner } from "../../../services/slice/statisticsSlice";
// import { useFacebookContext } from "react-facebook";

const TableBannerStatistics = ({ valueSearch, config, setConfig }) => {
  const dispatch = useDispatch();
  const statisticsState = useSelector(statisticsSelector);
  const { dataSatisticsBanner } = statisticsState;

  useEffect(() => {
    setConfig({
      search: valueSearch,
      properties: "views",
      option: {
        limit: 10,
        offset: 1,
        order: "asc",
      },
    });
  }, [valueSearch]);
  useEffect(() => {
    dispatch(getDataStatisticsBanner(config));
  }, [config]);
  const dataSource = useMemo(() => {
    const result = dataSatisticsBanner?.data?.map((item, index) => {
      return {
        ...item,
        STT:
          dataSatisticsBanner?.total > 10 && config.option.offset >= 2
            ? (config.option.offset - 1) * 10 + index + 1
            : index + 1,
        key: item.id,
        timeCreate: formatDate(item.timeCreate),
      };
    });
    return result;
  }, [dataSatisticsBanner?.data, dataSatisticsBanner?.total]);

  const columns = [
    {
      title: "STT",
      dataIndex: "STT",
      key: "STT",
      className: "centerCell",
      width: 90,
    },

    {
      title: <TranslateText text="Tên banner" />,
      dataIndex: "name",
      key: "name",
      className: "centerCell",
      ellipsis: {
        showTitle: false,
      },
      render: (name) => (
        <Tooltip placement="topLeft" title={name}>
          {name}
        </Tooltip>
      ),
    },
    {
      title: <TranslateText text="Ảnh" />,
      key: "click",
      className: "centerCell",
      dataIndex: "",
      render: (url, record) => {
        return (
          <Image
            style={{
              display: "block",
              objectFit: "contain",
            }}
            alt={`Image ${record.name}`}
            width={100}
            height={70}
            src={`${window.SERVER_URL_ADS}/${url.urlImage}`}
          />
        );
      },
    },
    {
      title: <TranslateText text="Liên kết" />,
      key: "link",
      className: "centerCell",
      dataIndex: "link",
    },
    {
      title: (
        <div className="textStatus">
          <TranslateText text="Lượt hiển thị" />
          <div className="iconSort">
            <IconSortUp
              fill={
                config.properties === "views" && config.option.order === "asc"
                  ? "#F66524"
                  : "#BDBDBD"
              }
              onClick={() =>
                setConfig({
                  ...config,
                  properties: "views",
                  option: { ...config.option, order: "asc" },
                })
              }
            />
            <IconSortDown
              fill={
                config.properties === "views" && config.option.order === "desc"
                  ? "#F66524"
                  : "#BDBDBD"
              }
              onClick={() =>
                setConfig({
                  ...config,
                  properties: "views",
                  option: { ...config.option, order: "desc" },
                })
              }
            />
          </div>
        </div>
      ),
      dataIndex: "views",
      key: "views",
      className: "centerCell",
    },
    {
      title: (
        <div className="textStatus">
          <TranslateText text="Lượt click" />
          <div className="iconSort">
            <IconSortUp
              fill={
                config.properties === "click" && config.option.order === "asc"
                  ? "#F66524"
                  : "#BDBDBD"
              }
              onClick={() =>
                setConfig({
                  ...config,
                  properties: "click",
                  option: { ...config.option, order: "asc" },
                })
              }
            />
            <IconSortDown
              fill={
                config.properties === "click" && config.option.order === "desc"
                  ? "#F66524"
                  : "#BDBDBD"
              }
              onClick={() =>
                setConfig({
                  ...config,
                  properties: "click",
                  option: { ...config.option, order: "desc" },
                })
              }
            />
          </div>
        </div>
      ),
      key: "click",
      className: "centerCell",
      dataIndex: "click",
    },
  ];
  const tableLoading = {
    spinning: false, // isLoading là biến boolean để xác định xem có đang loading hay không
    indicator: <IconSpin className="iconSpin" />,
  };
  return (
    <>
      <Row style={{ width: "100%" }}>
        <Table
          loading={tableLoading}
          className="TblProductStatistics"
          style={{ width: "100%", marginTop: "2.6rem" }}
          columns={columns}
          dataSource={dataSource}
          pagination={
            dataSatisticsBanner?.total > 10
              ? {
                  onChange: (value) => {
                    setConfig(() => ({
                      ...config,
                      option: {
                        ...config.option,
                        offset: value,
                      },
                    }));
                  },
                  current: config.option.offset,
                  defaultCurrent: config.option.offset,
                  total: dataSatisticsBanner?.total,
                  pageSize: 10,
                  prevIcon: <IconPre />,
                  nextIcon: <IconNext />,
                  showSizeChanger: false,
                }
              : false
          }
        />
      </Row>
    </>
  );
};

export default TableBannerStatistics;
